// import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import * as html2pdf from 'html2pdf.js';
import { UmsService } from '../ums.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
// import { HttpErrorResponse } from '@angular/common/http';
import { toWords } from 'number-to-words';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-payment-receipt',
  templateUrl: './payment-receipt.component.html',
  styleUrls: ['./payment-receipt.component.scss']
})
export class PaymentReceiptComponent implements OnInit {
  @ViewChild('contentToConvert') contentToConvert!: ElementRef;
  src;
  payHistory: FormGroup;
  payHistoryData: any;
  addmissionData: any;
  clgName: any;
  CoName: any;
  SnNo: any;
  FeeTable: any;
  TotalPaidAmountInWords: any;
  PreFix: any;
  formattedPrn: string;
  Transcript: boolean;
  TranscriptData: any;
  FeeType: any;
  MotherName: any;
  mobileNo: any;
  stuDOB: any;
  TransactionNo: any;
  studentPrn: any;
  FatherName: any;
  DateOfBirth: boolean;
  FullName: any;
  constructor(private fb: FormBuilder, public umsService: UmsService,
    public dialogRef1: MatDialogRef<PaymentReceiptComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private spinner: NgxSpinnerService,) { }
  // listOfFee: any;
  tempCo
  StudentPersonalId
  InstuName
  currentDate
  FirstName: string
  MiddleName: string
  LastName: string
  Number: number
  Email: string
  StudentId
  feeMode
  payModeee
  TotalPaidAmount
  showDownloadButton = true;
  generatingPDF = false;
  downloadingPDF: boolean = true;
  Currency
  reciptNumber
  RgNo
  // payHistoryData: any;
  ngOnInit(): void {
    // this.Currency = sessionStorage.getItem('Currency')
    this.getSecretData();
    this.getUserData(sessionStorage.getItem('StudentRGID'))
    this.getPersonalData(sessionStorage.getItem('StudentRGID'));
    this.prepopulationOfAddmission();
    this.currentDate = new Date();
    this.tempCo = this.data.TemplateCode
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.tempCo = this.data.TemplateCode
    this.StudentId = sessionStorage.getItem('StudentPersonalId');
    this.feeMode = sessionStorage.getItem('FeeMode');
    this.RgNo = sessionStorage.getItem('StudentRGID');
    this.transPRN(this.RgNo)
    console.log("feeeeeeeeee",this.data.CoName);
    this.CoName = this.data.CoName
    this.FeeType = this.data.Fee
    if(this.data.FeeType == 'PC' || this.data.FeeType == 'OPC' || this.data.FeeType == 'MC' || this.data.FeeType == 'RC'){
      this.DateOfBirth = false;
      this.clgName = this.data.CgName
    }
    else{
      this.DateOfBirth = true
    }
  }

  transPRN(RgNo){
    let RgNo1 = 99999;
this.formattedPrn = RgNo.toString().padStart(8, '0');
  }


  getData() {
    this.spinner.show();
    const payload = {};
    payload['TemplateCode'] = this.tempCo;
    payload['FeeType'] = ''
    // this.disablePaid = true;
    this.umsService.getFeeTemplet(payload).subscribe((res) => {
      this.spinner.hide()
      let data = res.data[0];
      this.Currency = data.Currency
      if (res.status) {
        this.FeeTable = res.data;
      } else {
        // this.umsService.openSnackbar(res.message);
      }
    });
  }


  downloadAsPDF() {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);
    const filename = `PaymentReceipt_${formattedDate}.pdf`;

    const options = {
      filename: filename,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    const element = this.contentToConvert.nativeElement;
    const buttons = element.querySelectorAll('button');
    buttons.forEach(button => {
        button.style.display = 'none';
    });

    html2pdf()
      .from(element)
      .set(options)
      .save()
      .then(() => {
        // Restore the visibility of the buttons after PDF generation is complete
        buttons.forEach(button => {
            button.style.display = '';
        });
    });
  }

  getSecretData() {
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      this.SnNo = res.projectPharam['SnNo']
      
      if(this.data.FeeType === 'TS'){
        
        this.getTranscriptHistory()
        this.getTranscript()
      }
      else{
        this.Transcript = false;
        this.getHistory(res.projectPharam['SnNo']);
      }
      this.InstuName = res.projectPharam['InstituteName']
      this.getData();
    })
  }
  getHistory(SnNo) {
    
    this.spinner.show();
    let payload = {};
    payload['FeeTemplateCode'] = this.tempCo;
    
    payload['FeeHistory'] = 1;
    payload['SnNo'] = this.data.SnNo;
    if(this.data.FeeType == 'PC' || this.data.FeeType == 'OPC' || this.data.FeeType == 'MC' || this.data.FeeType == 'RC'){
      payload['StuId'] = this.data.StuId
    }
    else{
      payload['StuId'] = this.StudentPersonalId ? this.StudentPersonalId : sessionStorage.getItem('StudentRGID');
    }
    payload['FeeType']=this.data.FeeType;
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      this.spinner.hide();
      this.payHistoryData = res.data;
      if(res.data[0].card_type == '-'){
        this.payModeee = 'Offline'
      }
      else{
        this.payModeee = res.data[0].card_type;
      }
      
      this.reciptNumber = res.data[0].PaymentResponseID;
      this.TransactionNo = res.data[0].txnid;
      if (res.data[0].FeeType == "EF") {
        this.Currency =  sessionStorage.getItem('ExamCurrency')
      }
      else {
        // this.Currency = sessionStorage.getItem('Currency')
        this.Currency = this.Currency
      }

      this.TotalPaidAmount = res.data[0].TotalPaidAmount
      this.convert( this.TotalPaidAmount)
    })

  }

  getTranscriptHistory(){
    this.spinner.show();
    let payload = {};
    payload['FeeTemplateCode'] = this.tempCo;
    payload['StuId'] = this.StudentPersonalId ? this.StudentPersonalId : this.data.StuId
    payload['FeeHistory'] = 0;
    payload['SnNo'] = this.data.SnNo;
    this.umsService.getSearchTranscriptFeeDetails(payload).subscribe((res) => {
      this.spinner.hide();
      this.payHistoryData = res.data;
      this.payModeee = res.data[0].card_type;
      this.reciptNumber = res.data[0].PaymentResponseID;
      if (res.data[0].FeeType == "EF") {
        this.Currency =  sessionStorage.getItem('ExamCurrency')
      }
      else {
        // this.Currency = sessionStorage.getItem('Currency')
        this.Currency = this.Currency
      }

      this.TotalPaidAmount = res.data[0].TotalPaidAmount
      this.convert( this.TotalPaidAmount)
      const customOrder = [
        "Transcript Fee",
        "Base Amount",
        "Per Additional Set For Transcript",
        "Postal Charges",
        "Hard Copy",
        "Per Additional Set For Delivery",
        "Soft Copy",
      ];
      
      this.payHistoryData = this.payHistoryData.sort((a, b) => {
        const normalizeName = (name: string) => {
          // Handle dynamic names by removing the "(x Set)" part
          return name.replace(/\s*\(\d+\s*Set\)/, "");
        };
        
        const indexA = customOrder.indexOf(normalizeName(a.FeeHead));
        const indexB = customOrder.indexOf(normalizeName(b.FeeHead));
      
        // If a name is not in the customOrder array, push it to the end
        return (indexA === -1 ? customOrder.length : indexA) - 
               (indexB === -1 ? customOrder.length : indexB);
      });
    })
  }

  normalizeFeeHead(name: string): string {
    // Remove dynamic "(x Set)" part
    return name.replace(/\s*\(\d+\s*Set\)/, "");
  }
  
  isSubhead(feeHead: string): boolean {
    const normalized = this.normalizeFeeHead(feeHead);
    return [
      'Per Additional Set For Transcript',
      'Hard Copy',
      'Soft Copy',
      'Base Amount',
      'Per Additional Set For Delivery'
    ].includes(normalized);
  }
  
  isHead(feeHead: string): boolean {
    const normalized = this.normalizeFeeHead(feeHead);
    return ['Transcript Fee', 'Postal Charges'].includes(normalized);
  }

  convert(number){
    this.TotalPaidAmountInWords = toWords(number);
  }

  getUserData(id) {
    
    this.Number = 0
    this.Email = ''
    this.umsService.getUserData(id).subscribe((res) => {
      // this.FirstName = res.data[0][0]['StuFirstName']
      // // this.MiddleName = res.data[0][0]['StuMidName']
      // this.LastName = res.data[0][0]['StuLastName']
      this.Number = parseInt(res.data[0][0]['StuMobNumber'])
      this.Email = res.data[0][0]['StuEmailId']
    });
  }

  getPersonalData(id){
    let payload = {}
    payload['StuRgNo'] = id;
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if(res.status){
       
      if(this.data.FeeType == 'PC' || this.data.FeeType == 'OPC' || this.data.FeeType == 'MC' || this.data.FeeType == 'RC'){
        // this.FirstName = this.data.StuName
        this.FullName = this.data.StuName
       this.MotherName = this.data.MotherName
       this.mobileNo = this.data.Mobile
       this.studentPrn = this.data.StuPRN
       this.FatherName = this.data.FatherName
      }
      else{
        this.FirstName = res.data[0]['StuFirstNameEng']
        this.MiddleName = res.data[0]['StuMiddleName']
       this.LastName = res.data[0]['StuLastNameEng']
       this.MotherName = res.data[0]['StuMothNameEng']
       this.mobileNo = res.data[0]['StuNumber']
       this.stuDOB = res.data[0]['StuBirthDate']
       this.studentPrn = res.data[0]['StuRgNoPrfx']
       this.FatherName = res.data[0]['StuMidNameEng']
       this.FullName = res.data[0]['StuFullNameEng']
      }
      }
      else{
        // this.FirstName = this.data.StuName
        this.FullName = this.data.StuName
       this.MotherName = this.data.MotherName
       this.mobileNo = this.data.Mobile
       this.studentPrn = this.data.StuPRN
       this.FatherName = this.data.FatherName
      }
      
    });

  }


  close() {
    this.dialogRef1.close();
  }


  prepopulationOfAddmission() {
    // this.spinner.show();
    this.StudentPersonalId = sessionStorage.getItem("StudentPersonalId");
    let payload = {};
    payload['StuId'] = this.StudentPersonalId ? this.StudentPersonalId : this.data.StuId
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      if (res.status) {
        console.log(res,'pre');
        this.addmissionData = res.data[0];
        
        this.getclg(res.data[0]);
        this.getCourse(res.data[0])
      }
    })
  }

  getclg(data) {
    let payload = {};
    payload['CgCode'] = data.StuCgId
    this.umsService.getCollege(payload).subscribe((res) => {
      console.log('this.data for college',this.data);
      
      if(this.data.FeeType == 'PC' || this.data.FeeType == 'OPC' || this.data.FeeType == 'MC' || this.data.FeeType == 'RC'){
        this.DateOfBirth = false;
        this.clgName = this.data.CgName
      }
      else{
        this.clgName = res.data[0].CgName
      }
    })

  }


  getCourse(data) {
    let payload = {};
    payload['CoCode'] = data.StuCoId
    this.umsService.fetchCourseType(payload).subscribe((res) => {
      if(res.status){
        this.CoName = res.data[0].CoName
        this.PreFix = res.data[0].CoRgPrfx
      }
      else{
        this.CoName = this.data.CoName
      }
      
    },(ERROR:HttpErrorResponse) => {
      this.CoName = this.data.CoName
    })

  }


  generateSingleFiveDigitReceiptNumber(): string {
    const randomNumber = Math.floor(Math.random() * 100000); // Generate random number between 0 and 99999
    const formattedNumber = randomNumber.toString().padStart(5, '0'); // Ensure it's formatted to have 5 digits with leading zeros
    return formattedNumber;
  }

  getTranscript(){
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    let payload = {};
    payload['StuId'] = this.StudentPersonalId ? this.StudentPersonalId : this.data.StuId
    this.umsService.SearchTranscript(payload).subscribe((res) => {
      if(res.status){
        this.TranscriptData = res.data[0]
        this.Transcript = true;
      }
      else{

      }
    });
  }


}